const dndItems = {
    icon: "ICON",
    tab: "TAB",
    partition: "PARTITION",
    subpartition: "SUBPARTITION"
}

export default dndItems;